import axios from "axios";
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import qs from 'qs';

export const corporateGroupService = {
  getList,
  getById,
  storeOrUpdate,
  destroy,
  verifyPin,
  getLoraOrganisations
};

/**
 * Fetch the list of LoRa organisations (for linking a corporate group).
 * Returns { code, data: [{id, name}] } or null. System-admin only on the API.
 */
function getLoraOrganisations() {
  return axios
    .get(`${apiEndpoint.loraSensors}/organisations`, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : null))
    .catch((err) => (err.response ? err.response.data : null));
}

/**
 * Get all corporate groups
 */
function getList(includeInactive = false) {
  const queryString = qs.stringify({
    include_inactive: includeInactive
  }, { addQueryPrefix: true });

  return axios
    .get(
      `${apiEndpoint.corporateGroups}${queryString}`,
      {
        headers: authHeader(),
      }
    ).then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

/**
 * Get single corporate group by ID
 */
function getById(id) {
  return axios
    .get(
      `${apiEndpoint.corporateGroups}/${id}`,
      {
        headers: authHeader(),
      }
    ).then(res => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
    });
}

/**
 * Create or update a corporate group
 */
function storeOrUpdate(data, id = null) {
  return (id ? (
    axios
      .put(
        `${apiEndpoint.corporateGroups}/${id}`,
        data,
        {
          headers: authHeader(),
        }
      )
  ) : (
    axios
      .post(
        `${apiEndpoint.corporateGroups}`,
        data,
        {
          headers: authHeader()
        }
      )
  )).then(res => {
    if (res && res.status === 200) {
      return res.data;
    }
    return {};
  });
}

/**
 * Verify a 4-digit PIN against a corporate group.
 * Returns the raw response so callers can distinguish "no PIN" vs "wrong PIN".
 */
function verifyPin(id, pin) {
  return axios
    .post(
      `${apiEndpoint.corporateGroups}/${id}/verify-pin`,
      { pin },
      {
        headers: authHeader(),
      }
    )
    .then((res) => (res && res.status === 200 ? res.data : null))
    .catch((err) => (err.response ? err.response.data : null));
}

/**
 * Delete a corporate group
 */
function destroy(id) {
  return axios
    .delete(
      `${apiEndpoint.corporateGroups}/${id}`,
      {
        headers: authHeader()
      }
    ).then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}
